<template>
    <Modal ref="modalRef" :processing="form.processing" :show-primary-button="false" max-width="md">
        <template #title>{{ trans('profile.sms_notifications.header') }}</template>

        <p class="mb-4 text-gray-600">
            {{ trans('profile.sms_notifications.disable.description') }}
        </p>

        <p class="text-gray-600">
            {{ trans('profile.sms_notifications.disable.reconnect_hint') }}
        </p>

        <template #footer>
            <jet-button style="flex: 1" type="button" variant="secondary" @click="closeModal">
                {{ trans('general.action.cancel') }}
            </jet-button>
            <jet-button :is-processing="form.processing" style="flex: 1" @click="disableSmsAlerts">
                {{ trans('profile.sms_notifications.action.disable') }}
            </jet-button>
        </template>
    </Modal>
</template>

<script setup>
import JetButton from '@/Jetstream/Button.vue';
import { router, useForm } from '@inertiajs/vue3';
import { ref } from 'vue';

const modalRef = ref(null);

const form = useForm({});

const disableSmsAlerts = () => {
    form.delete(route('user.phone.disable'), {
        preserveScroll: true,
        onSuccess: () => {
            modalRef.value?.emit('numberDisabled');
            modalRef.value?.close();
            router.reload({ only: ['user'] });
        },
    });
};

const closeModal = () => {
    modalRef.value?.close();
};
</script>
